export class ServiceOptions {
  userId: number;
  originApp: string;
  serviceName: string;
  lang: string;
  token: number;
  urldecodeSw: number;
  constructor() {
    this.originApp = "BROSH_WEB";
  }
}
